import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
export var Separator = function (_a) {
    var className = _a.className;
    return _jsx("div", { className: twMerge('border-neutral flex border-[1.5px]', className) });
};
